/**
 *
 * Asynchronously loads the component for Ben004
 * Author: Locnt
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
